<script>
  import CommentAjax from '@ajax/comment';

  import Track from '@utils/track';

  import CreateAccountModal from '@app-components/modal/CreateAccountModal.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import { getGroupStore } from '@stores/group';

  let commentStore = getGroupStore('commentStore');

  export let comment;
  export let mobile = false;
  export let group;
  export let recObject;
  export let rootComment;
  export let parentComment;
  export let toggleReplies = null;
  export let expanded = false;
  export let reFetchRecObject;
  export let customContext;

  let likesCount = comment.likes_count;
  let liked = comment.liked;
  let repliesCount = rootComment ? comment.replies.filter((reply) => !reply.flagged).length : 0;
  let hasFlaggedRepliesOnly =
    rootComment && comment.replies.length > 0 && comment.replies.every((reply) => reply.flagged);

  let currentUser = getCurrentUserStore('default');
  currentUser.subscribe((x) => (currentUser = x));

  let createAccountModal = false;

  export let toggleLike = async function () {
    if (!currentUser || !currentUser.id) {
      showCreateAccountModal();
      return;
    }

    if (liked) {
      likesCount -= 1;
    } else {
      likesCount += 1;
    }
    liked = !liked;
    await CommentAjax.toggleLike(comment.id);
    reFetchRecObject();
  };

  let showCreateAccountModal = function () {
    createAccountModal = true;
  };

  let trackAccountCreated = function () {
    Track.commentLikeAccountCreated({
      user: currentUser,
      group,
      recObject,
      comment,
    });
  };
  const repliesCountDisplay = function () {
    if (hasFlaggedRepliesOnly) {
      return 'View replies';
    }
    return `${repliesCount} ${repliesCount == 1 ? 'reply' : 'replies'}`;
  };
</script>

<style style="text/scss" lang="scss">
  .comment-actions {
    position: relative;
    margin: 6px 0 0 42px;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #a19bb8;
    span {
      margin-left: 16px;
      &.like {
        cursor: pointer;
        background: url(/images/comment/heart.svg) no-repeat 0 48%;
        background-size: 12px;
        padding-left: 20px;
        &.liked {
          background: url(/images/comment/heart-red.svg) no-repeat 0 48%;
        }
      }
      &.reply {
        cursor: pointer;
        background: url(/images/comment/reply.svg) no-repeat 0 50%;
        background-size: 12px;
        padding-left: 20px;
      }
      &.count {
        cursor: pointer;
        position: absolute;
        right: 2px;
        top: 0;
        font-weight: 500;
        color: #ae94f9;
      }
    }
  }
</style>

{#if createAccountModal}
  <div>
    <CreateAccountModal
      mobile={mobile}
      eventDetails={{ trigger_event: 'add_comment', group_base_id: group?.id, rec_object_id: recObject?.id }}
      successCallback={() => {
        createAccountModal = false;
        trackAccountCreated();
        toggleLike();
      }}
      showPassword={true}
      saveButtonFlow={true}
      bind:showModal={createAccountModal}
      beforeDataSend={(data) => {
        data['sign_up_source'] = {
          source: 'comment_like',
          group_base_id: group && group.id,
          rec_object_id: recObject && recObject.id,
          comment_id: comment.id,
        };
        return data;
      }} />
  </div>
{/if}

<div class="comment-actions">
  <span
    class="like {liked ? 'liked' : ''}"
    on:click|preventDefault|stopPropagation={() => {
      toggleLike();
    }}>
    {#if likesCount == 0}
      Like
    {:else}
      {likesCount} like{likesCount == 1 ? '' : 's'}
    {/if}
  </span>
  <span
    class="reply"
    on:click|preventDefault|stopPropagation={() => {
      commentStore.set({
        comment: comment,
        reply: true,
        parent: parentComment || comment,
        context: customContext || (recObject && recObject.id ? 'rec' : 'list'),
      });
    }}>Reply</span>
  {#if rootComment && (repliesCount > 0 || hasFlaggedRepliesOnly)}
    <span
      class="count"
      on:click|preventDefault|stopPropagation={() => {
        toggleReplies(comment);
      }}>
      {expanded ? 'Hide' : repliesCountDisplay()}
    </span>
  {/if}
</div>
